import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { Settings } from '../../core';
import { SponsorRouteData } from '../sponsor-route-data';
import { HttpClient } from '@angular/common/http';
import { TableauStorage } from './tableau-storage';
import { DOCUMENT } from '@angular/common';
import { IMdlCustomDialogConfiguration, MdlDialogService } from '@angular-mdl/core';
import { TableauDialogComponent } from './tableau-dialog.component';
import * as XLSX from 'xlsx';
declare var tableau: any;
var viz: any;
var viz2: any;

@Component({
    selector: 'tableau',
    template: require('./tableau.component.html'),
    styles: [require('./tableau.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableauComponent {

    public dashboardUrl: string;
    public listOfReportSumary: any = [];
    public vizOptions: any = {
        hideTabs: true,
        hideToolbar: true,
        Protocol: '',
        SPONSOR_NAME: '',
        onFirstInteractive: () => {
            //     this.subMenu = true;
            //     this.listOfReportSumary = [];
            //     let self = this;
            //     self.listOfReportSumary = [];
            //     this.changeDetectorRef.markForCheck();
            //     viz.getWorkbook().getActiveSheet().getWorksheets().map((sheet: any) => {
            //         if (sheet['_impl']['$5'].indexOf('Report:') > -1) {
            //             self.listOfReportSumary.push({ 'name': sheet['_impl']['$5'].replace('Report:', ''), 'value': sheet['_impl']['$5'] });
            //         }
            //     });
            setTimeout(
                () => {
                    let containerDiv2 = this.document.getElementById('vizContainer2');
                    let newUrl = this.selectedDashboard.contentUrl.replace('/token', '').replace('/trusted', '').split('/');
                    newUrl[(newUrl.length) - 1] = newUrl[(newUrl.length) - 1].replace('Dashboard', 'Download');
                    newUrl = newUrl.join('/');
                    this.globalViz2 = new tableau.Viz(containerDiv2, newUrl, this.vizOptions2);
                    viz2 = this.globalViz2;
                },
                1);
        }
    };
    public vizOptions2: any = {
        hideTabs: true,
        hideToolbar: true,
        Protocol: '',
        SPONSOR_NAME: '',
        onFirstInteractive: () => {
            this.subMenu = true;
            this.listOfReportSumary = [];
            let self = this;
            self.listOfReportSumary = [];
            this.changeDetectorRef.markForCheck();
            viz2.getWorkbook().getActiveSheet().getWorksheets().map((sheet: any) => {
                if (sheet['_impl']['$5'].indexOf('Report:') > -1) {
                    self.listOfReportSumary.push({ 'name': sheet['_impl']['$5'].replace('Report:', ''), 'value': sheet['_impl']['$5'] });
                }
            });
        }
    };
    public containerDiv: any;
    public globalViz: any;
    public globalViz2: any;
    public dashboards: any[];
    public dashboardName: string[];
    public loadDashboard: boolean;
    public subMenu: boolean;
    public elem: any;
    public isFullScreen: boolean;
    public selectedDashboard: any;
    public excelTypeFormate: any[];
    public fileName = 'ExcelSheet.xlsx';
    public isSummaryVisible: boolean;
    public dashboardWithDownloadOption: any[];

    @ViewChild('btn2') public btn2: any;
    @ViewChild('m2') public m2: any;
    constructor(
        private routeData: SponsorRouteData,
        protected settings: Settings,
        protected http: HttpClient,
        private tableauStorage: TableauStorage,
        private changeDetectorRef: ChangeDetectorRef,
        @Inject(DOCUMENT) private document: any,
        private dialogServce: MdlDialogService
    ) {
        this.dashboardUrl = '';
        this.vizOptions.Protocol = this.routeData.snapshot.selectedStudy.protocolName;
        this.vizOptions2.Protocol = this.routeData.snapshot.selectedStudy.protocolName;
        this.vizOptions.SPONSOR_NAME = this.routeData.snapshot.selectedStudy.sponsorName;
        this.vizOptions2.SPONSOR_NAME = this.routeData.snapshot.selectedStudy.sponsorName;
        this.getDashboardData();
        let self = this;
        document.onfullscreenchange = function (event: any) {
            if (!document.fullscreenElement &&    // alternative standard method
                !document['mozFullScreenElement'] && !document['webkitFullscreenElement'] && !document['msFullscreenElement']) {
                self.isFullScreen = false;
                self.changeDetectorRef.markForCheck();
            } else {
                self.isFullScreen = true;
                self.changeDetectorRef.markForCheck();
            }
        };
    }

    // Initial visualization load
    public initViz() {
        this.containerDiv = document.getElementById('vizContainer');
        let vizUrl = this.dashboardUrl + '?:device=desktop';
        this.loadViz(this.containerDiv, vizUrl, this.vizOptions);
        this.elem = document.getElementById('tableauView');
    }

    public checkForReport() {
        return this.listOfReportSumary.length > 0;
    }

    public loadViz(containerDiv: any, url: any, options: any) {
        if (this.globalViz) {
            this.globalViz.dispose();
        }
        if (viz) {
            viz.dispose();
        }

        if (this.globalViz2) {
            this.globalViz2.dispose();
        }
        if (viz2) {
            viz2.dispose();
        }

        this.globalViz = new tableau.Viz(containerDiv, url, options);
        viz = this.globalViz;
        viz.addEventListener(tableau.TableauEventName.FILTER_CHANGE, this.onFilterValueChange);
        // setTimeout(
        //     () => {
        //         let containerDiv2 = document.getElementById('vizContainer2');
        //         let newUrl = url.split('/');
        //         newUrl[(newUrl.length) - 1] = newUrl[(newUrl.length) - 1].replace('Dashboard', 'Download');
        //         newUrl = newUrl.join('/');
        //         this.globalViz2 = new tableau.Viz(containerDiv2, newUrl, this.vizOptions2);
        //         viz2 = this.globalViz2;
        //     },
        //     100);


    }

    public onFilterValueChange(e: any) {


        e.getFilterAsync().then(function (param: any) {
            let worksheet: any;
            let activeSheetName = viz2.getWorkbook().getActiveSheet().getName();
            let updatedValue = param.getAppliedValues();
            if (Array.isArray(updatedValue)) {
                updatedValue = [];
                param.getAppliedValues().map((val: any, i: any) => {
                    updatedValue[i] = val.value;
                });
            }
            let filterName = param.getFieldName();
            viz2.getWorkbook().activateSheetAsync(activeSheetName).then(function (sheet: any) {
                worksheet = sheet;
            }).then(function () {

                return worksheet.getWorksheets()[worksheet.getWorksheets().length - 1].applyFilterAsync(filterName, updatedValue, tableau.FilterUpdateType.REPLACE);
            });

            //   viz2.getWorkbook().changeParameterValueAsync(setFieldName, value).then(
            //     () => { console.log('Parameter is updated' + value); }
            //   );

            // }
            // else if (getFieldNameTreatment.includes(param.getFieldName())) {
            //   viz.getWorkbook().changeParameterValueAsync(setFieldName, '(All)').then(
            //     () => { console.log('Parameter is updated' + "All"); }
            //   );
            // }
        });
    }


    public getDashboardData() {
        this.tableauStorage.getAllDashboards(this.routeData.snapshot.selectedStudy).subscribe((value) => {
            this.dashboards = value;
            this.loadDashboard = true;
            if (this.dashboards.length) {
                this.onSelection(this.dashboards[0]);
            }
            this.changeDetectorRef.markForCheck();
        });
    }

    public async onSelection(selectedDashboard: any) {
        this.selectedDashboard = '';
        this.dashboardUrl = '';
        if (selectedDashboard) {
            this.tableauStorage.getTrustedToken(this.routeData.snapshot.selectedStudy).subscribe(res => {
                this.selectedDashboard = selectedDashboard;
                this.changeDetectorRef.markForCheck();
                this.dashboardUrl = this.formUrl(res, selectedDashboard.contentUrl);
                this.initViz();
            });

        }
    }

    public formUrl(token: string, contentUrl: string) {
         return contentUrl.replace('token', token);
       // return contentUrl.replace('/token', '').replace('/trusted', '');
    }

    // Opens the Download to PDF dialog box
    public exportToPDF() {

        if (this.globalViz) {
            this.globalViz.showExportPDFDialog();
        } else {
            viz.showExportPDFDialog();
        }

    }

    // Opens the Download Image dialog box
    public exportImage() {

        if (this.globalViz) {
            this.globalViz.showExportImageDialog();
        } else {
            viz.showExportImageDialog();
        }
    }

    // Opens the  PPT dialog box
    public exportPPT() {
        if (this.globalViz) {
            this.globalViz.showExportPowerPointDialog();
        } else {
            viz.showExportPowerPointDialog();
        }
    }

    public exportexcel(records: any): void {
        /* table id is passed over here */
        // let element = document.getElementById('excel-table');
        //const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
        try {

            let ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(records);
            this.excelTypeFormate.map((res: any) => {
                if (res.type === 'integer') {
                    this.sheet_set_column_format(ws, res.coulmn, '0');
                } else if (res.type === 'float') {
                    this.sheet_set_column_format(ws, res.coulmn, '0.00');
                }
            });


            /* generate workbook and add the worksheet */
            const wb: XLSX.WorkBook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');


            /* save to file */
            XLSX.writeFile(wb, this.fileName, { type: 'buffer' });

        } catch (ex) {

        }

    }

    public formatJson(header: any, data: any, fileName: any) {

        try {
            let self: any = this;
            let formatedData: any = [];
            this.excelTypeFormate = [];
            let skipIndex: any = [];
            //remove unwanted  coloumn
            //  let removeExcelArray = AppSettings.removeColoumnInExcel;
            //   headerold.map((head:any, index:any) => {
            //     if (head.getFieldName() && removeExcelArray.length && (new RegExp('\\b' + removeExcelArray.join('\\b|\\b') + '\\b')).test(head.getFieldName().toLowerCase())) {
            //       skipIndex.push(index);
            //     } else {
            //       header.push(head);
            //     }
            //   })

            header.map((res: any, index: any) => {
                if (res.getDataType() === 'integer') {
                    this.excelTypeFormate.push({ coulmn: index, type: 'integer' });
                } else if (res.getDataType() === 'float') {
                    this.excelTypeFormate.push({ coulmn: index, type: 'float' });
                }
            });

            data.map((row: any, i: any) => {
                let rowObj: any = {};
                let counter = 0;
                row.map((cell: any, index: any) => {
                    if (skipIndex.includes(index)) {
                        counter++;
                    } else {
                        if (header[index - counter].getDataType() === 'date' || header[index - counter].getDataType() === 'datetime') {
                            rowObj[header[index - counter].getFieldName()] = cell.formattedValue && cell.formattedValue !== 'Null' ? new Date(cell.formattedValue) : 'Null';
                        } else {
                            rowObj[header[index - counter].getFieldName()] = cell.formattedValue.trim();
                        }
                    }

                });
                formatedData[i] = rowObj;
            });
            setTimeout(
                () => {
                    self.fileName = fileName;
                    self.exportexcel(formatedData);
                },
                100);
        } catch (ex) {

        }
    }

    public sheet_set_column_format(ws: any, C: any, Z: any) {
        var range = XLSX.utils.decode_range(ws['!ref']);
        var x = XLSX;
        var y = XLSX.SSF.get_table();
        /* this loop starts on the second row, as it assumes the first row is a header */
        for (var R = range.s.r + 1; R <= range.e.r; ++R) {
            var cell = ws[XLSX.utils.encode_cell({ r: R, c: C })];
            if (!cell) { continue; }
            if (cell.v !== 'Null') {
                if (Z === '0') {
                    cell.t = 'n';
                    if (cell.v) {
                        cell.v = parseInt((cell.v).replace(',', ''), 10);
                    }

                } else if (Z === '0.00') {
                    cell.t = 'n';
                    if (cell.v) {
                        cell.v = parseFloat((cell.v).replace(',', ''));
                    }

                }
                cell.z = Z;
            }
        }
    }

    public viewDataSummary(report: any) {
        //this.globalViz.showExportDataDialog()

        let sheet = viz2.getWorkbook().getActiveSheet().getWorksheets().get(report);
        if (!sheet) {
            sheet = this.globalViz2.getWorkbook().getActiveSheet().getWorksheets().get(report);
        }
        let options = {
            maxRows: 0, // Max rows to return. Use 0 to return all rows
            ignoreAliases: false,
            ignoreSelection: true,
            includeAllColumns: false
        };
        let self = this;
        sheet.getSummaryDataAsync(options).then(function (t: any) {

            try {
                let tableData = t.getData();
                let tableHeader = t.getColumns();

                self.fileName = report + 'Summary.xlsx';

                self.formatJson(tableHeader, tableData, self.fileName);
            } catch (ex) {

            }

        });
    }

    public toggleView() {
        this.isSummaryVisible = !this.isSummaryVisible;
        let self = this;
        let cevent = event;
        setTimeout(
            () => {
                self.m2.show(cevent, self.btn2);
            },
            10);

    }


    public checkForFullMode() {
        if (sessionStorage.getItem('fullmode')) {
            this.openFullscreen();
        }
    }

    public openFullscreen() {
        if (!document.fullscreenElement) {
            if (this.elem.requestFullscreen) {
                this.elem.requestFullscreen();
            } else if (this.elem.mozRequestFullScreen) {
                /* Firefox */
                this.elem.mozRequestFullScreen();
            } else if (this.elem.webkitRequestFullscreen) {
                /* Chrome, Safari and Opera */
                this.elem.webkitRequestFullscreen();
            } else if (this.elem.msRequestFullscreen) {
                /* IE/Edge */
                this.elem.msRequestFullscreen();
            }
        } else {
            this.backToNormalMode();
        }
    }
    public backToNormalMode() {
        if (document['exitFullscreen']) {
            document['exitFullscreen']();
        }
    }

    public openDialog() {
        const configDialog: IMdlCustomDialogConfiguration = {
            component: TableauDialogComponent,
            providers: [{
                provide: 'selectedDashboard', useValue: this.selectedDashboard
            }],
            styles: {
                'min-width': '1040px'
            },
            isModal: true,
            clickOutsideToClose: true,
            classes: 'scrollable'
        };

        this.dialogServce.showCustomDialog(configDialog);
    }
}